export default ({
  createUniqueId,
}) => ({
  /**
   * Creates a new flash notification.
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} state
   * @param {Object} config
   * @return {Promise}
   */
  async create({ commit, dispatch }, config) {
    await dispatch('immediateDismiss')
    const id = createUniqueId([])

    let resolver
    const { duration = 6000 } = config
    const promise = new Promise((internalResolver) => {
      resolver = internalResolver
    })

    if (duration) {
      setTimeout(() => {
        dispatch('dismiss', id)
        resolver()
      }, duration)
    } else {
      resolver()
    }

    commit('ADD', { ...config, hiding: false, id })

    await promise
  },

  /**
   * Dismisses a flash notification.
   *
   * This applies a delay to the removal to allow the animation to complete.
   *
   * @param {Function} commit
   * @return {Promise}
   */
  async dismiss({ commit }, id) {
    let resolver
    const promise = new Promise((internalResolver) => {
      resolver = internalResolver
    })

    commit('HIDE', id)

    setTimeout(() => {
      commit('REMOVE', id)
      resolver()
    }, 600)

    await promise
  },

  /**
   * Dismisses a flash notification with no delay.
   *
   * @param {Function} commit
   * @return {Promise}
   */
  immediateDismiss({ commit }) {
    return commit('REMOVE')
  },
})
